///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: 'div[windeGridActionsCell]',
    standalone: false
})
export class GridActionsCellDirective {
    @HostBinding('class') buttonClass = 'winde-grid-cell winde-grid-actions-cell';
    @HostBinding('style.max-width') @Input() maxWidth: string;
}
